import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Components
import AboutMeLeftCard from '../Components/AboutMeLeftCard';

function AboutMeSection() {
    return (
        <Container fluid={true} className="about-me-container">
            <h3 className="display-5 font-weight-light text-center border-bottom">My Skills</h3>

            <Row className="justify-content-center mt-3">
                <Col md={11} sm={12} className="">
                    <AboutMeLeftCard />
                </Col>
            </Row>
        </Container>
    );
}

export default AboutMeSection;